import { Controller } from "@hotwired/stimulus";
import IMask from "imask";
import type { InputMask, FactoryArg, FactoryOpts } from "imask";

export type ImaskedElement<T> = T & {
  imask: InputMask<FactoryArg>;
  imaskOptions: FactoryOpts;
};

const normalizeMask = (options: FactoryOpts): FactoryOpts => {
  if (!options) {
    return options;
  }

  if (options instanceof String) {
    return options;
  }

  if (Array.isArray(options.mask)) {
    return {
      ...options,
      mask: options.mask.map((mask) =>
        mask instanceof Object ? normalizeMask(mask as FactoryOpts) : mask
      )
    };
  }
  if (options.mask === "Number") {
    options.mask = Number;
  }
  if (options.mask === "IMask.MaskedEnum") {
    options.mask = IMask.MaskedEnum;
  }

  if (options.mask === "IMask.MaskedRange") {
    options.mask = IMask.MaskedRange;
  }

  if ("blocks" in options && options.blocks instanceof Object) {
    Object.keys(options.blocks).forEach((key) => {
      if (options.blocks && key in options.blocks) {
        options.blocks[key] = normalizeMask(options.blocks[key] as FactoryOpts);
      }
    });
  }

  return options;
};

export default class extends Controller<ImaskedElement<HTMLInputElement>> {
  static values = {
    mask: Object
  };

  declare readonly maskValue: FactoryOpts | string;

  connect() {
    const inputField = this.element;

    let maskOptions: FactoryOpts = {};
    if (this.maskValue instanceof Object) {
      maskOptions = this.maskValue as FactoryOpts;
    } else {
      maskOptions = { mask: this.maskValue };
    }

    inputField.imaskOptions = normalizeMask(maskOptions);

    inputField.imask = IMask(inputField, inputField.imaskOptions);
  }
}
